<div *ngIf="loaded">
  <div id="ap-tiny-editor-container"
       class="ap-editor-container"
       [ngClass]="{'required': isRequired(), 'required-invalid': form?.submitted && apEditorFormControl?.invalid, 'showRequriedOnly' : isShowRequriedOnly()}">
    <div [collapse]="!hasWarning"
         [isAnimated]="false">
      <span id="ap-tiny-editor-warning"
            class="ap-editor-warning alert alert-warning alert-dismissible"
            role="alert">
        <span class="ap-editor-warning-text"
              [innerHTML]="warningMessage"></span>
        <div id="ap-tiny-editor-warning-close-x"
             class="close"
             (click)="closeWarning()">&times;</div>
      </span>
    </div>
    <editor #editorInstance
            [id]="editorId"
            [init]="tinymceOptions"
            [(ngModel)]="editorValue"
            (ngModelChange)="onEditorValueChanged()"
            (onDirty)="onDirty()">
    </editor>
    <div class="incorrect-input"
         *ngIf="isRequired() && form?.submitted && apEditorFormControl?.invalid">
      {{(displayName || editorName) + ' is a required field'}}
    </div>
  </div>
</div>
